import React from "react";
import { useParticipantDetails } from "../../../context/participantDetails";
import { useRegDetail } from "shared/context/regDetail";
import CustomQRCode from "shared/components/CustomQRCode";
import BorderLoaderAnimation from "shared/components/borderLoaderAnimation";
import DateTimeHelper from "shared/utils/dateTimeHelper";
import useCountDownTimerHook from "../../../../../shared/hooks/useCountDownTimerHook";

export default function MyPrivilegesQrCodeWrapper() {
  const { badgeQRConfiguration } = useRegDetail();
  const badgeValidityInSeconds = React.useMemo(() => {
    return (badgeQRConfiguration?.validityInMillis || 0) / 1000;
  }, [badgeQRConfiguration?.validityInMillis]);

  const { participantDetails, refreshParticipantDetails } = useParticipantDetails();

  const { secondsLeft: secondsRemaining, reInitialiseTimer } = useCountDownTimerHook({
    countDownSeconds: badgeValidityInSeconds
  });

  React.useEffect(() => {
    if (secondsRemaining === badgeValidityInSeconds) {
      refreshParticipantDetails();
    }
    if (secondsRemaining <= 0) {
      reInitialiseTimer();
    }
  }, [refreshParticipantDetails, secondsRemaining, reInitialiseTimer, badgeValidityInSeconds]);

  return (
    <div className="myPrivileges_qrCodeInner">
      <span className="myPrivileges_qrCodeInner_timer">
        {DateTimeHelper.getSecondsToMinutesFormat(secondsRemaining)}
      </span>
      <BorderLoaderAnimation animationDurationInSec={`${badgeValidityInSeconds}s`}>
        <React.Fragment>
          <CustomQRCode
            value={participantDetails?.ptBadgeQRData || ""}
            size={150}
            qrStyle={"dots"}
            eyeRadius={4}
            eyeColor={"#404258"}
          />
        </React.Fragment>
      </BorderLoaderAnimation>
    </div>
  );
}
